import { gql, useQuery } from "@apollo/client";

const MY_WITHDRAWAL_RIGHTS = gql`
  query myWithdrawalRights {
    myWithdrawalRights {
      purchaseKey
      orderId
      purchasedAtUtc
      withdrawalDeadlineUtc
      canRequest
      planTypes
      totalLessons
      request {
        id
        status
        requestedAtUtc
      }
    }
  }
`;

export type MyWithdrawalRight = {
  purchaseKey?: string | null;
  orderId?: string | null;
  purchasedAtUtc: string;
  withdrawalDeadlineUtc: string;
  canRequest: boolean;
  planTypes: string[];
  totalLessons: number;
  request?: {
    id: string;
    status: string;
    requestedAtUtc: string;
  } | null;
};

type MyWithdrawalRightsData = {
  myWithdrawalRights: MyWithdrawalRight[];
};

export function useMyWithdrawalRights() {
  const { data, loading, refetch } = useQuery<MyWithdrawalRightsData>(
    MY_WITHDRAWAL_RIGHTS,
    { fetchPolicy: "network-only" },
  );

  return {
    withdrawalRights: data?.myWithdrawalRights ?? [],
    loading,
    refetch,
  };
}
